import config from "../../config/config";
import { Typegroup_service } from "../services/Typegroup.service";
import { Operator_service } from "../services/Operator_service";
import { MessageBox, Loading } from 'element-ui';
import router from "../router/router"
import { dispatch } from "rxjs/internal/observable/pairs";
const state = {
    total: 0,
    dataTable: [],
    ungroup: [],
    prepare: null
};
const actions = {
    async addTypegroup({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Typegroup_service.addTypeGroup(data);
        if (result.status === 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                // router.push({ name: 'Typegroup' })
            }).catch(() => {
                // router.push({ name: 'Typegroup' })
            });
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async queryAlltable({ commit }, data) {
        state.dataTable = [];
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Typegroup_service.queryAlltable(data);
        if (result.status === 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            commit('UPDATE_TOTAL', result.data[0].total)
            for (var i = 0; i < result.data.length; i++) {
                commit('UPDATE_TABLE', result.data[i])
            }
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async updateTypegroup({ commit }, data) {
        state.dataTable = [];
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Typegroup_service.updateTypegroup(data);
        if (result.status === 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('แก้ไขข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Typegroup' })
            }).catch(() => {
                router.push({ name: 'Typegroup' })
            });
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async removeTypegroup({ commit }, data) {
        let result = await Typegroup_service.removeTypegroup(data);
        if (result.status === 200) {
            commit('REMOVE_ROW', data)
            let total = state.total - 1
            commit('UPDATE_TOTAL', total)
            MessageBox.confirm('ลบข้อมูลเรียบร้อยแล้ว', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            })
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async getUngroupProviders({commit}, formdata){
        let result = await Operator_service.getUngroupProvider()
        if(result.data.result){
            commit('SET_UNGROUP_PROVIDER',result.data.result)
        }
    },

    async update_typegroup({commit, dispatch}, row_id){
        let result = await Typegroup_service.getProviderGroupById(row_id)
        if(result.status == 200){
            dispatch('getUngroupProviders')
            commit('PREPARE_EDIT', result.data[0])
            router.push({name: 'Edit_typegroup'})
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    }
};

const mutations = {
    UPDATE_TABLE(state, data) {
        state.dataTable.push({
            type: data.provider_type === 'mobile' ? 'โทรศัพท์เคลื่อนที่' : 'อินเทอร์เน็ตความเร็วสูงประจำที่',
            namebrand: data.group_name_th,
            logo: config.API_URL + data.group_logo,
            codecolor: data.group_color_code,
            info: data
        })
    },
    UPDATE_TOTAL(state, data) {
        state.total = data;
    },
    REMOVE_ROW(state, data) {
        var index = state.dataTable.findIndex(row => row.info.id == data)
        state.dataTable.splice(index, 1)
    },
    SET_UNGROUP_PROVIDER(state, data){
        state.ungroup = data
    },
    PREPARE_EDIT(state,data){
        state.prepare = data
        state.prepare.logo = config.API_URL+data.group_logo
    }
};

export const Typegroup = {
    namespaced: true,
    state,
    actions,
    mutations
};